import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { Button as ButtonUnstyled } from '@mui/base'

import './button.scss'

export const RemoveButton = ({ children, ...props }) => {
  return (
    <ButtonUnstyled className={'button remove'} {...props}>
      <FontAwesomeIcon icon={faXmark} />
      {children}
    </ButtonUnstyled>
  )
}
